import { React, useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import { useSnackbar } from 'notistack';
import TokenService from '../../../services/TokenService';
import PickupRequestDetail from '../../Pickups/PickupRequestDetail'
import TodaysCounts from './TodaysCounts.jsx';
import Profits from './Profits.jsx';
import MonthlyProfits from './MonthlyProfits.jsx';
import OrderListTable from '../../Pickups/OrderListTable.jsx';
import AdminOrderView from '../../Pickups/AdminOrderView.jsx';
import Slide from '@mui/material/Slide';
import SortableFilterTable from '../../SortableFilterTable.jsx';
import RecyclerItem from '../RecyclerItem.jsx';
import cloneDeep from 'lodash/cloneDeep';
import Avatar from '@mui/material/Avatar';
import MarketingRequestItem from './MarketingRequestItem.jsx'
import dayjs from 'dayjs';
import Button from '@mui/material/Button';
import ConfirmDialog from '../../Modals/ConfirmDialog';
import DenyCharityReasonModal from '../../Modals/DenyCharityReasonModal';

export default function AdminCounts(props) {
    var utc = require('dayjs/plugin/utc');
    dayjs.extend(utc);
    var duration = require('dayjs/plugin/duration');
    dayjs.extend(duration);
    var relativeTime = require('dayjs/plugin/relativeTime');
    dayjs.extend(relativeTime);

    const [orders, setOrders] = useState(null);
    const [recyclers, setRecyclers] = useState(null);
    const [pendingMarketingRequests, setPendingMarketingRequests] = useState(null);
    const [charitiesNeedingReview, setCharitiesNeedingReview] = useState(null);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [fetchingOrders, setFetchingOrders] = useState(false);
    const [viewType, setViewType] = useState('');
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [confirmDialog, setConfirmDialog] = useState(null);
    const [denyCharityModal, setDenyCharityModal] = useState(null);

    function viewOrders(orderType) {
        //alert(orderType);
        setFetchingOrders(true);
        setViewType(orderType);
        TokenService.adminServicePost({ reportType: orderType }, 'Admin_DashboardCountsReport')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let data = JSON.parse(response.JsonData);
                    setOrders(data);
                    setRecyclers(null);
                    setPendingMarketingRequests(null);
                    setCharitiesNeedingReview(null);
                    setFetchingOrders(false);
                    window.setTimeout(function () {
                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
                    }, 200)
                }
            })
            .catch((response) => {
                enqueueSnackbar('Error in Todays Counts', {
                    variant: 'error',
                });
            });
    }

    function viewRecyclers(viewType, items) {
        setOrders(null);
        if (items !== undefined && items.length > 0) {

            if (viewType == 'PendingMarketingRequests') {
                setPendingMarketingRequests(items);
                setRecyclers(null);
            }
            else {
                setRecyclers(items);
                setPendingMarketingRequests(null);
            }
            setCharitiesNeedingReview(null);
            window.setTimeout(function () {
                window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
            }, 200)
        }
    }

    function showCharitiesPendingReview() {
        setFetchingOrders(true);
        //setViewType(orderType);
        TokenService.adminServicePost('', 'Admin_DashboardCharitiesNeedingReview')
            .then((response) => {
                if (response.Result == undefined) {
                    response = response[Object.keys(response)[0]];
                }
                
                if (response.Result == "SUCCESS") {
                    let data = JSON.parse(response.JsonData);
                    setOrders(null);
                    setRecyclers(null);
                    setPendingMarketingRequests(null);
                    setCharitiesNeedingReview(data);
                    setFetchingOrders(false);
                    window.setTimeout(function () {
                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
                    }, 200)
                }
            })
            .catch((response) => {
                enqueueSnackbar('Error in Todays Counts', {
                    variant: 'error',
                });
            });
    }

    function buildOrdersSkeleton() {
        return (<div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton width={75} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton width={75} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton width={75} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton width={75} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton width={25} height={25} style={{ alignSelf: 'center' }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton width={75} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton width={75} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton width={75} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton width={75} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton width={25} height={25} style={{ alignSelf: 'center' }} />
            </div>
        </div>)
    }

    

    function handleOrderSelected(order) {
        setSelectedOrder(order);
    }

    function buildOrders() {
        return (
            <div>
                <OrderListTable Orders={orders} loggedInUser={props.loggedInUser} Section='Admin' SectionDetail={viewType} OrderSelected={handleOrderSelected} />
            </div>

        )
    }

    function buildRecyclers() {

        let tableData = [];


        let columns = [
            {
                name: 'Photo',
                mappedProperty: 'Photo',
                dataType: 'none',
                canFilter: false
            },
            {
                name: 'First',
                mappedProperty: 'FirstName',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Last',
                mappedProperty: 'LastName',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Email',
                mappedProperty: 'EmailAddress',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Open',
                mappedProperty: 'OpenOrders',
                dataType: 'numeric',
                canFilter: true
            },
            {
                name: 'Completed',
                mappedProperty: 'CompletedOrders',
                dataType: 'numeric',
                canFilter: true
            }

        ]

        return (<div>
            {recyclers.map((recycler, index) => {
                let dataItem = cloneDeep(recycler);
                dataItem.Photo = <Avatar
                    alt="Photo"
                    src={recycler.ReturnerPhoto}
                    sx={{ width: 40, height: 40, alignSelf: 'center' }}
                />
                tableData.push(dataItem);
            })
            }
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>Results: {recyclers.length}</div>
            <SortableFilterTable data={tableData} columns={columns} expandRow={(data) => handleRecyclerRowExpanded(data)} uniqueIdentifierProperty={'ID'} />
        </div>)
    }

    function buildPendingMarketingRequests() {
        let tableData = [];


        let columns = [
            {
                name: 'Photo',
                mappedProperty: 'Photo',
                dataType: 'none',
                canFilter: false
            },
            {
                name: 'First',
                mappedProperty: 'FirstName',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Last',
                mappedProperty: 'LastName',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Email',
                mappedProperty: 'EmailAddress',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Hrs Old',
                mappedProperty: 'HoursOld',
                dataType: 'numeric',
                canFilter: true
            }


        ]

        return (<div>
            {pendingMarketingRequests.map((recycler, index) => {
                let dataItem = cloneDeep(recycler);
                dataItem.Photo = <Avatar
                    alt="Photo"
                    src={recycler.ReturnerPhoto}
                    sx={{ width: 40, height: 40, alignSelf: 'center' }}
                />
                dataItem.HoursOld = (dataItem.MinutesOld / 24).toFixed(1);
                tableData.push(dataItem);
            })
            }
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>Results: {pendingMarketingRequests.length}</div>
            <SortableFilterTable data={tableData} columns={columns} expandRow={(data) => handleMarketingRequestRowExpanded(data)} uniqueIdentifierProperty={'ID'} />
        </div>)
    }

    function buildCharitiesNeedingReview() {
        let tableData = [];

        /*
        	DonationId = 0;
			DonationTitle = "";
			CompanyName = "";
            CompanyEmail = "";
            PayeeName = "";
            Memo = "";
            CompanyAddress = "";
			CompanyAddress2 = "";
			CompanyCity = "";
			CompanyState = "";
			CompanyZipcode = "";
			CompanyType = "";
            CompanyDescription = "";
            Website = "";
            StartDate = new WCFDate();

            EndDate = new WCFDate();
            Tag = "";
			TotalDonated = 0;
            PaymentMethod = "";
            ACH_RoutingNumber = "";
            ACH_AccountNumber = "";
            ACH_AccountType = "";
            State = "";
            Zipcodes = new List<string>();
            QuickAccessTag = "";
            CentroidLatitude = 0;
            CentroidLongitude = 0;
            NonProfitIDNumber = "";
            Password = "";
            Images = new List<DonationImage>();
            */
        let columns = [
            {
                name: 'Type',
                mappedProperty: 'CompanyType',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Title',
                mappedProperty: 'DonationTitle',
                dataType: 'string',
                canFilter: false
            },
            {
                name: 'Name',
                mappedProperty: 'CompanyName',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Email',
                mappedProperty: 'CompanyEmail',
                dataType: 'string',
                canFilter: true
            },
          
           

        ]

        return (<div>
           
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>Results: {charitiesNeedingReview.length}</div>
            <SortableFilterTable data={charitiesNeedingReview} columns={columns} expandRow={(data) => handleCharityExpanded(data)} uniqueIdentifierProperty={'DonationId'} />
        </div>) 
    }

    function handleCharityExpanded(charity) {
        if (1 == 1) {

        }
        return (<div style={{padding:'10px'} }>
            {charity.NonProfitIDNumber === '' ? null :
                <div> NonProfit ID: {charity.NonProfitIDNumber}</div>
            }
            {charity.Website === '' ? null : 
                <div> Website: {charity.Website}</div>
            }
            <div>Payee Name: {charity.PayeeName}</div>
            <div>Payment Method: {charity.PaymentMethod}</div>
            <div>Desription: {charity.CompanyDescription}</div>
            <div>Payment Method: {charity.PaymentMethod}</div>
            {charity.PaymentMethod === 'ACH' ?
                <>
                    <div>Routing Number: {charity.ACH_RoutingNumber} <a target='_blank' href={'https://www.frbservices.org/EPaymentsDirectory/achResults.html?bank=&aba=' + charity.ACH_RoutingNumber + '&state=+&city=+&submitButton=Search&referredBy=searchAchPage'}>Lookup</a></div>
                    <div>Account Number: {charity.ACH_AccountNumber}</div>
                    <div>Account Type: {charity.ACH_AccountType}</div>
                </>
                :null
            }
            {charity.CompanyAddress === '' ? null :
                <>
                    <div>Address: {charity.CompanyAddress}</div>
                    <div style={{ marginLeft: '30px' }}>{charity.CompanyAddress2}</div>
                    <div style={{ marginLeft: '30px' }}>{charity.CompanyCity}, {charity.CompanyState} {charity.CompanyZipcode}</div>
                </>
            }

            {charity.CompanyType == 'Fundraiser' ?
                <>
                    <div>Start Date: {dayjs(charity.StartDate.Data).format('MM-DD-YYYY')}</div>
                    <div>End Date: {dayjs(charity.EndDate.Data).format('MM-DD-YYYY')}</div>
                </>
                :null
            }

            {charity.Images.map((img, idx) => {
                return (<div><img src={img.ImagePath} style={{maxWidth:'400px'} } /></div>)
            })}

            <div style={{display:'flex'} }>
                <Button variant='outlined' onClick={() => verifyApproveCharity(charity) }>Approve</Button>
                <Button variant='outlined' onClick={() => verifyDenyCharity(charity)} style={{marginLeft:'25px'} }>Deny</Button>
            </div>
           
        </div>)
    }

    function verifyApproveCharity(charity) {
       
        setConfirmDialog({
            show: true,
            close: closeVerifyApproveCharity,
            title: 'Approve ' + charity.CompanyType ,
            cancelText: 'Cancel',
            acceptText: 'Approve',
            content: <div>
                <div>Do you want to Approve this {charity.CompanyType}?</div>
                <div>This will email them an approval.</div>
            </div>,
            data: charity
        });
    }

    function closeVerifyApproveCharity(didAccept, charity) {
        if (didAccept) {
            let postData = {
                id: charity.DonationId,
                didApprove: true,
                reason: ''
            }
            setFetchingOrders(true);
            TokenService.adminServicePost(postData, 'Admin_UpdateCharityReview')
                .then((response) => {
                    if (response.Result == undefined) {
                        response = response[Object.keys(response)[0]];
                    }

                    if (response.Result == "SUCCESS") {
                        let data = JSON.parse(response.JsonData);
                        setOrders(null);
                        setRecyclers(null);
                        setPendingMarketingRequests(null);
                        setCharitiesNeedingReview(data);
                        setFetchingOrders(false);
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Error in Update Charity', {
                        variant: 'error',
                    });
                });
        }
        setConfirmDialog(null);
    }

    function verifyDenyCharity(charity) {
        setDenyCharityModal(charity);
    }

    function handleVerifyDenyCharityClosed(didAccept, charity, reason) {
        if (didAccept) {
            let postData = {
                id: charity.DonationId,
                didApprove: false,
                reason: reason
            }
            setFetchingOrders(true);
            TokenService.adminServicePost(postData, 'Admin_UpdateCharityReview')
                .then((response) => {
                    if (response.Result == undefined) {
                        response = response[Object.keys(response)[0]];
                    }

                    if (response.Result == "SUCCESS") {
                        let data = JSON.parse(response.JsonData);
                        setOrders(null);
                        setRecyclers(null);
                        setPendingMarketingRequests(null);
                        setCharitiesNeedingReview(data);
                        setFetchingOrders(false);
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Error in Update Charity', {
                        variant: 'error',
                    });
                });
        }
        setDenyCharityModal(null);
    }

    function handleRecyclerUpdated(recycler) {
        // alert('handleRecyclerUpdated not yet implemented');
    }

    function handleRecyclerRowExpanded(recycler) {
        return <RecyclerItem recycler={recycler} onUpdate={(recycler) => handleRecyclerUpdated(recycler)} />
    }

    function handleMarketingRequestRowExpanded(request) {
        return <MarketingRequestItem MarketingRequest={request} />
    }

    function handleOrderUpdated(updatedOrder) {
        let ordersTemp = [];
        for (let i = 0; i < orders.length; i++) {
            if (updatedOrder.RequestID == orders[i].RequestID) {
                ordersTemp.push(updatedOrder);
            }
            else {
                ordersTemp.push(orders[i]);
            }
        }
        setOrders(ordersTemp);
    }


    return (<div style={{ marginBottom: '200px' }}>
        <Slide direction="right" in={selectedOrder === null} mountOnEnter unmountOnExit >
            <div>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '10px', flexWrap: 'wrap' }}>

                    <Profits />
                    <MonthlyProfits />
                    <TodaysCounts viewOrders={(orderType) => viewOrders(orderType)} viewRecyclers={(viewType, recyclers) => viewRecyclers(viewType, recyclers)} showCharitiesPendingReview={() => showCharitiesPendingReview()} />
                </div>
                {orders == null ? null :

                    fetchingOrders ?
                        buildOrdersSkeleton()
                        :
                        buildOrders()
                }

                {recyclers == null ? null :
                    buildRecyclers()
                }
                {pendingMarketingRequests == null ? null :
                    buildPendingMarketingRequests()
                }
                {charitiesNeedingReview == null ? null :
                    buildCharitiesNeedingReview()  
                }
            </div>
        </Slide>
        <Slide direction="left" in={selectedOrder !== null} mountOnEnter unmountOnExit >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Card sx={{ minWidth: 300, maxWidth: 600, width: '100%', alignSelf: 'center', margin: '0px', padding: '0px' }}>

                    <CardContent style={{ padding: '5px' }}>
                        <div>
                            <AdminOrderView
                                orderUpdated={handleOrderUpdated}
                                order={selectedOrder}
                                onBack={() => setSelectedOrder(null)}
                                loggedInUser={props.loggedInUser}
                            />
                        </div>
                    </CardContent>
                </Card>
            </div>
        </Slide>
        {confirmDialog !== null ?
            <ConfirmDialog Close={confirmDialog.close} Title={confirmDialog.title} Content={confirmDialog.content} CancelText={confirmDialog.cancelText} AcceptText={confirmDialog.acceptText} Data={confirmDialog.data} />
            : null
        }

        {denyCharityModal == null ? null :
            <c onClose={handleVerifyDenyCharityClosed} charity={denyCharityModal} />
        }

        
    </div>
    )
}